import { createSlice } from "@reduxjs/toolkit";

const chatSlice = createSlice({
  name: "chat",
  initialState: {
    isOpen: false, 
    isMinimized: false,
    chatType: "general",
    careerGoal: null,
    messages: [], 
    conversations: {}, 
    activeConversation: null, 
    isLoadingConversationMessages: false,
    isSendingConversationMessage: false,
    realTimeEnabled: false,
  },
  reducers: {
    openChat: (state) => {
      state.isOpen = true;
      state.isMinimized = false; 
    },
    closeChat: (state) => {
      state.isOpen = false;
      state.isMinimized = false;
    },
    setChatType: (state, action) => {
      state.chatType = action.payload;
    },
    setCareerGoal: (state, action) => {
      state.careerGoal = action.payload;
    },
    setMinimizeChat: (state, action) => {
      state.isMinimized = action.payload;
    },
    clearChat: (state) => {
      state.messages = []; // Clears chat messages
    },
    
    // New conversation actions
    setActiveConversation: (state, action) => {
      state.activeConversation = action.payload;
    },
    setConversationMessages: (state, action) => {
      const { conversationId, messages } = action.payload;
      state.conversations[conversationId] = messages;
    },
    addMessageToConversation: (state, action) => {
      const { conversationId, message } = action.payload;
      if (!state.conversations[conversationId]) {
        state.conversations[conversationId] = [];
      }
      state.conversations[conversationId].push(message);
    },
    setLoadingConversationMessages: (state, action) => {
      state.isLoadingConversationMessages = action.payload;
    },
    setSendingConversationMessage: (state, action) => {
      state.isSendingConversationMessage = action.payload;
    },
    setRealTimeEnabled: (state, action) => {
      state.realTimeEnabled = action.payload;
    },
    clearConversation: (state, action) => {
      const conversationId = action.payload;
      if (conversationId) {
        delete state.conversations[conversationId];
      } else {
        state.conversations = {};
      }
    },
  },
});

export const {
  openChat,
  closeChat,
  setChatType,
  setCareerGoal,
  setMinimizeChat,
  clearChat,
  setActiveConversation,
  setConversationMessages,
  addMessageToConversation,
  setLoadingConversationMessages,
  setSendingConversationMessage,
  setRealTimeEnabled,
  clearConversation,
} = chatSlice.actions;
export default chatSlice.reducer;
